import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Col, Container, Form, Modal, Row } from "react-bootstrap";
import adminLayout from "../../hoc/adminLayout";
import { Link } from "react-router-dom";
import { BaseUrl, token } from "../../utils/Token";
import { toast } from "react-toastify";
import excelfile from "../../assets/images/mysampleexcel.xlsx"
import Loader from "../../common/Loader";

// it is category List And this View Product

function ViewProduct() {
  const [product, setProduct] = useState([]);
  let userid = localStorage.getItem("userid")
  const [open, setopen] = useState(false)

  const [show, setShow] = useState(false);
  const [file, setfile] = useState(null)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    console.log(token);
  });

  const fetchData = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/product`, {
        headers,
      });
      setProduct(response.data.data);
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const getRowId = (row) => row._id;
  const handleEditClick = (id) => {

  };

  const columns = [
    // { field: "_id", headerName: "ID", width: 300 },
    // { field: "phone", headerName: "Vendor Phone", width: 250 },
    { field: "short_name", headerName: "Short Name", width: 250 },
    { field: "long_name", headerName: "Long Name", width: 250 },
    // {
    //   field: "image",
    //   headerName: "image",
    //   width: 250,
    // },
    {
      field: "image",
      headerName: "image",
      width: 200,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${BaseUrl}/${value}`}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 140,
      renderCell: (params) => {
        const id = params.row._id;
        return (
          <Link to={`/product_single/${id}`}>
            <IconButton
              style={{ color: "black" }}
              aria-label="edit"
              onClick={() => handleEditClick(id)}
            >
              <EditIcon />
            </IconButton>
          </Link>
        );
      },
    },

    {
      field: "Add",
      headerName: "Add Variant",
      width: 140,
      renderCell: (params) => {
        const id = params.row._id;
        return (
          <Link to={`/addVariant/${id}`}>
            <i
              className="fa-solid fa-circle-plus text-dark"
              onClick={() => handleEditClick(id)}
            ></i>
          </Link>
        );
      },
    },

    {
      field: "view",
      headerName: "View Variant",
      width: 140,
      renderCell: (params) => {
        const id = params.row._id;
        return (
          <Link to={`/viewvariant/${id}`}>
            <i
              className="fa-solid fa-eye text-dark"
              onClick={() => handleEditClick(id)}
            ></i>
          </Link>
        );
      },
    },

    {
      field: "delete",
      headerName: "Delete",
      width: 140,
      renderCell: (params) => {
        const id = params.row._id;
        return (
          <Link>
            <IconButton
              color="primary"
              aria-label="edit"
              onClick={() => handledeleteClick(id)}
            >
              <i className="fa-sharp fa-solid fa-trash text-dark"></i>
            </IconButton>
          </Link>
        );
      },
    },
  ];

  const handledeleteClick = async (id) => {
    let data = JSON.stringify({
      _id: id,
      deleted_at: "D",
    });

    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${BaseUrl}/product`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.status == "OK") {
          window.location.reload(true);
          // try {
          //   const res = axios.get("https://twinscart.com:8000/section", {
          //     headers,
          //   });

          //   window.location.reload(true);
          // } catch (error) {
          //   console.error("Error fetching category data:", error);
          // }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const handleFilebaseUpload = (event) => {
    const selectbasefile = event.target.files[0];
    setfile(selectbasefile);
  };






  const handleExcelSubmit = (e) => {
    e.preventDefault()
    setopen(true)

    let formdata = new FormData()
    formdata.append("vendor", userid);
    formdata.append("excel_file", file);
    axios.post(`${BaseUrl}/upload_base_excel`, formdata, { headers }).then((res) => {

      if (res.data.status == "OK") {
        toast.success("File Upload Successfully")
        setopen(false)
        setShow(false)
        fetchData()
      }
    }).catch((err) => {
      toast.error("File Not Upload")
      setopen(false)
    })
  }




  return (
    <>
      <Loader open={open} />
      <section>
        <Container>
          <Row>
            <div className="col-md-12">

              <div className="row align-items-center">
                <div className="col-md-6">
                  <h4 className="px-3 py-3">Product List</h4>
                </div>
                <div className="col-md-6">
                  <div className="text-end">
                    <button className="btn bg-primary text-white" onClick={(e) => setShow(true)}>Upload Excel</button>
                  </div>
                </div>
              </div>
            </div>
            <Col md="12">
              <div className="bg-white  box">
                <div className="">
                  <DataGrid
                    rows={product}
                    columns={columns}
                    getRowId={getRowId}
                    initialState={{
                      ...product.initialState,
                      pagination: { paginationModel: { pageSize: 10 } },
                    }}
                    pageSizeOptions={[5, 10, 25]}
                  // checkboxSelection
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>


      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body>
          <div className="text-end">
            <a className="bg-dark text-white btn" href={excelfile} download>Download Sample Excel</a>
          </div>
          <Form onSubmit={(e) => handleExcelSubmit(e)}>
            <label htmlFor="" className="fw-bold">Excel</label>
            <input type="file" className="form-control" onChange={handleFilebaseUpload} />

            <button className="btn bg-primary text-white mt-2">Submit</button>
          </Form>
        </Modal.Body>

      </Modal>


    </>
  );
}

export default adminLayout(ViewProduct);
